import { render } from "./Reports.vue?vue&type=template&id=5c9b399a"
import script from "./Reports.vue?vue&type=script&lang=js"
export * from "./Reports.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Task/Partials/Reports.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5c9b399a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5c9b399a', __exports__)) {
    console.log('reload')
    api.reload('5c9b399a', __exports__)
  }
  
  module.hot.accept("./Reports.vue?vue&type=template&id=5c9b399a", () => {
    console.log('re-render')
    api.rerender('5c9b399a', render)
  })

}


export default __exports__